import React, { useEffect, useRef, useState } from 'react';

import FavoritesTopbar from './FavoritesTopbar';

import { useTranslation } from 'react-i18next';
import { CustomExhibitions } from '../../components';
import AuthService from '../../security/AuthService';
import { Button } from 'primereact/button';
import {  useNavigate, useParams } from 'react-router-dom';
import eventBus from '../../common/EventBus';
import ProfileService from '../../service/ProfileService';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import Constants from '../../constants/Constants';
import ExhibitionService from '../../service/ExhibitionService';
import FavoriteService from '../../service/FavoriteService';


export const Favorites = (props) => {
    const { t } = useTranslation();
    const toast = useRef(null);
    const navigate = useNavigate();


    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    const [itemWidth, setItemWidth] = useState(250);
    const itemHeight = 410;

    let { profileId, userType } = useParams();



    const [followerVisible, setFollowerVisible] = useState(false);
    const [followedVisible, setFollowedVisible] = useState(false);

    const [follower, setFollower] = useState([]);
    const [followed, setFollowed] = useState([]);


    const [favorites, setFavorites] = useState([]);
    const [status, setStatus] = useState(Constants.favoriteFileType.ALL);

  const [selectedExhibit,setSelectedExhibit]=useState();
    

    useEffect(() => {
        loadFavorites(status);
    }, []);



    const loadFavorites= async (param) => {
        setDisplayLoadingDialog(true);
        setFavorites([]);
        FavoriteService.inquireFavorites( param).then(
            (response) => {
                console.log("inquireExhibitByStatus", response)
                console.log("inquireExhibitByStatus", response?.data?.data?.dataList)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireExhibitByStatus", response?.data?.data?.dataList)
                    setFavorites(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibitByStatus logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );

    }



    const onAddFavorite = (exhibit, entityName, artwork) => {

        console.log("onAddFavorite");
        setDisplayLoadingDialog(true);

        let userId = AuthService.getUserId();

        let rowId = exhibit.id;
        if (Constants.entityNames.artwork === entityName) {
            rowId = artwork?.id
        }

        let apiParams = { userId, entityName, rowId }

        console.log("onAddFavorite", apiParams);

        FavoriteService.add(apiParams).then(
            (response) => {

                console.log("onAddFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave", response?.data?.data?.id);
                    if (Constants.entityNames.artwork === entityName) {
                        artwork.favoriteId = response?.data?.data?.id;
                    } else {
                        exhibit.favoriteId = response?.data?.data?.id;
                    }

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onRemoveFavorite = (exhibit, artwork) => {

        console.log("onRemoveFavorite");
        setDisplayLoadingDialog(true);

        let userId = AuthService.getUserId();


        let apiParams = { id: exhibit.favoriteId }

        console.log("onRemoveFavorite", apiParams);

        FavoriteService.remove(apiParams).then(
            (response) => {

                console.log("onRemoveFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    
                    if (artwork) {

                        

                        setFavorites(favorites.filter(favorite => favorite.id !== artwork.id && favorite.filterType != Constants.favoriteFileType.artwork));
                    } else {
                        setFavorites(favorites.filter(favorite => favorite.id !== exhibit.id && favorite.filterType != Constants.favoriteFileType.exhibit));
                    }
                    console.log("onSave", response);

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onStatusChange = (param) => {
        let _param=param;
        if(param==status){
            _param=Constants.favoriteFileType.ALL;
        }

        setStatus(_param);
        loadFavorites(_param);
    }

    const onSelectedExhibit=(param)=>{
        console.log("onSelectedExhibit",param)
        navigate("/exhibition/view/" + param.id );
    }

    


    return (
        <div className='root-profile' style={{ paddingBottom: 70 }}>

        <div className='surface-profile-header'>
            <Toast ref={toast} />
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>

            <FavoritesTopbar></FavoritesTopbar>

            <div style={{ padding: '1.5rem 2rem' ,marginBottom: '2rem'}}>
                <span className="block text-6xl  mb-1  p-2">
                    {t('favorites_header_with_user', { username: AuthService.getFullName() }) }
                </span>
                <div style={{
                    flexDirection: 'row',
                    display: 'flex',
                    //   justifyContent: 'space-between',
                    padding: 10,
                }}
                >
                    <span className="block text-2xl  mb-1  p-2">
                        {t('exhibit_filter_header')}
                    </span>

                    <Button className={status === Constants.favoriteFileType.artwork ? "p-button-rounded mr-2 mb-2 p-2" : "p-button-rounded p-button-gray mr-2 mb-2"} label={t("favorites_filter_type_artwork")} onClick={() => onStatusChange(Constants.favoriteFileType.artwork)} />
                   
                    <Button className={status === Constants.favoriteFileType.exhibition ? "p-button-rounded mr-2 mb-2" : "p-button-rounded p-button-gray mr-2 mb-2"} label={t("favorites_filter_type_exhibition")} onClick={() => onStatusChange(Constants.favoriteFileType.exhibition)} />

                </div>
                <CustomExhibitions hasAction={true} exhibits={favorites} labelStyle={{ color: "#000000" }} onAddFavorite={onAddFavorite} onRemoveFavorite={onRemoveFavorite} onSelectedExhibit={onSelectedExhibit}></CustomExhibitions>

            </div>
        </div >
        </div >
    );
};

